import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueFilterDateParse from './libs/dateParse.js'
import Multiselect from 'vue-multiselect'
import Vuelidate from 'vuelidate'


// register globally
Vue.use(Vuelidate)
Vue.component('multiselect', Multiselect)
Vue.use(VueFilterDateParse);
Vue.use(VueFilterDateFormat);
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.mixin({
  methods: {
    defaultHeaders() {
      //  console.log("defaultHeaders: ", this.getBearerToken());
      return {
        "Content-type": "application/json",
        authorization: this.getBearerToken(),
      };
    },
    getBearerToken() {
      return "Bearer " + store.state.token;
    },
    apiGetSecure(url) {
      return fetch(url, {
        method: "GET",
        headers: this.defaultHeaders(),
      }).catch((error) => {
        //  console.log("api error", error);
        throw error;
      })
    },

    apiGetSecureWithParams(url, params) {
      //  console.log("apiGetSecureWithParams params: ", JSON.stringify(params));
      // console.log("token", this.getBearerToken());
      return fetch(url, {
        method: "GET",
        headers: this.defaultHeaders(),
        params: params
      }).catch((error) => {
        //    console.log("api error", error);
        throw error;
      })
    },

    apiPostSecure(url, body) {
      return fetch(url, {
        method: "POST",
        headers: this.defaultHeaders(),
        body: JSON.stringify(body),
      }).catch((error) => {
        //  console.log("api error in apiPostSecure", error);
        throw error;
      })
    },

    apiPostSecureWithParams(url, params, body) {
      // console.log("apiPostSecureWithParams params: ", JSON.stringify(params));
      //  console.log("token", this.getBearerToken());
      return fetch(url, {
        method: "POST",
        headers: this.defaultHeaders(),
        params: params,
        body: JSON.stringify(body),
      }).catch((error) => {
        //  console.log("api error", error);
        throw error;
      })
    },
  }
})

const init = () => {
  new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    components: {
      App
    }
  })
}

import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

let firebaseConfig = {
  apiKey: "AIzaSyARKvutAvYE7UpTlkbsp5i-fObZ9u21ae0",
  authDomain: "deaf-e-learning.firebaseapp.com",
  projectId: "deaf-e-learning",
  storageBucket: "deaf-e-learning.appspot.com",
  messagingSenderId: "117314574617",
  appId: "1:117314574617:web:b75b7675042e52a8120d88",
  measurementId: "G-N5T458D84V"
};

if (process.env.VUE_APP_FIREBASE_AUTH_ENV == 'production') {
  firebaseConfig = {
    apiKey: "AIzaSyALz4PGNWhJVuHV5OrrGKCVQrM3O1RvAw0",
    authDomain: "edusign-live.firebaseapp.com",
    projectId: "edusign-live",
    storageBucket: "edusign-live.appspot.com",
    messagingSenderId: "726524610919",
    appId: "1:726524610919:web:1bfed6273fce010b8dc7c2",
    measurementId: "G-KTC5M5PY93"
  };
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}
firebase.analytics();

let globalUser;

function checkUserLoggedIn() {
  console.log("checkUserLoggedIn()");
  if (globalUser) {
    globalUser.getIdTokenResult()
      .then((idTokenResult) => {
        let newToken = idTokenResult.token;
        let oldToken = store.state.token;
        if (newToken != oldToken) {
          store.commit("addUser", idTokenResult);
        }
        console.log("timer", idTokenResult);
      })
      .catch((error) => {
        console.log("timer", error);
      });
  }
}
setInterval(checkUserLoggedIn, 60000);


firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    globalUser = user;
    user.getIdTokenResult()
      .then((idTokenResult) => {
        store.commit("addUser", idTokenResult);
        init() //Note: for prefilled roles        
      })
      .catch((error) => {
        init()
        //  console.log(error);
      });
    //  console.log("$store", store);
  } else {
    init()
    // User is signed out.
    // ...
    // console.log("user not logged in");
    router.push({ path: `/auth/login` });
  }
});


